import React from 'react';
import useLocations from '@ubeya/shared/hooks/account/useLocations';
import { FlexMiddle } from '../../Flex';

const PreferredAreaChip = ({ value }) => {
  const { mappedLocations } = useLocations();

  if (!Array.isArray(value)) {
    return <FlexMiddle>{mappedLocations[value]?.name || value}</FlexMiddle>;
  }

  return (
    <FlexMiddle>
      {value
        .map((item) => mappedLocations[item]?.name)
        .filter(Boolean)
        .join(', ')}
    </FlexMiddle>
  );
};

export default PreferredAreaChip;
